import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { FormattedMessage, injectIntl } from 'react-intl';
import reduxForm from 'redux-form/es/reduxForm';
import Field from 'redux-form/es/Field';
import { isMobile } from 'utils/helpers';
import Button from 'components/common/Button';
import InputDateRangePicker from 'components/common/controls/InputDateRangePicker';

const propTypes = {
  contractId: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
};

class TransactionsSearchForm extends Component {
  constructor() {
    super();
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(data) {
    const { onSubmit, contractId } = this.props;
    const { startDate, endDate } = data.transactionsDatesRange;
    onSubmit(contractId, startDate, endDate);
  }

  isOutsideRange(day) {
    return !day.isSameOrBefore();
  }

  render() {
    const { handleSubmit, intl } = this.props;

    return (
      <form className="form" onSubmit={handleSubmit(this.onSubmit)}>
        <div className="grid">
          <div className="grid__item two-thirds palm-one-whole">
            <Field
              name="transactionsDatesRange"
              component={InputDateRangePicker}
              startDatePlaceholderText={intl.formatMessage({ id: 'selfservice.transactions.labelFrom' })}
              endDatePlaceholderText={intl.formatMessage({ id: 'selfservice.transactions.labelTo' })}
              isOutsideRange={this.isOutsideRange}
              numberOfMonths={isMobile ? 1 : 2}
              isFullWidth
            />
          </div>
          <div className="grid__item one-third palm-one-whole">
            <Button isFullWidth>
              <FormattedMessage id="selfservice.transactions.search" />
            </Button>
          </div>
        </div>
      </form>
    );
  }
}

const transactionsSearchFormConfig = {
  form: 'transactionsSearchForm',
  initialValues: {
    transactionsDatesRange: {
      startDate: moment().subtract(1, 'month').format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
    },
  },
  onSubmitFail: (error) => {
    if (DEBUG) {
      console.warn('form submit fail', error);
    }
  },
};

TransactionsSearchForm.propTypes = propTypes;
TransactionsSearchForm.contextTypes = {
  intl: PropTypes.object,
};

export default injectIntl(reduxForm(transactionsSearchFormConfig)(TransactionsSearchForm));
